import "./carousel.scss";

import React, { useCallback, useEffect, useMemo, useState } from "react";

import { getCenterIndex, LogVerbose } from "../../../services/utilities";
import { carouselContext } from "./carouselContext";

export const CarouselProvider = ({
    nSlides: numSlides,
    name,
    extraClass,
    children,
    centerIndex: assignedCenterIndex,
    refSlideIndex,
    looping = false,
    centerize = false,
    autoPlayOnStart = false, autoPlayInterval = 5000
}: {
    name?: string;
    centerize?: boolean;
    centerIndex?: number;
    refSlideIndex?: number;
    nSlides?: number;
    extraClass?: string;
    looping?: boolean;
    autoPlayOnStart?: boolean;
    autoPlayInterval?: number;
    children: React.ReactNode;
}) => {
    const initialCenterIndex = assignedCenterIndex || getCenterIndex({ nSlides: numSlides, centerize });
    const [activeIndex, setActiveIndex] = useState<number>(initialCenterIndex || 0);
    const [autoPlay, setAutoPlay] = useState<boolean>(autoPlayOnStart === true);
    const [nSlides, setNSlides] = useState<number>(numSlides || 0);
    const [centerIndex, setCenterIndex] = useState<number | undefined>(initialCenterIndex);

    // useEffect(() => {
    //     console.log(`CarouselProvider: useEffect - activeIndex changed: ${activeIndex}`);
    // }, [activeIndex]);

    useEffect(() => {
        const centerOffset = getCenterIndex({ nSlides, centerize });
        if (centerOffset) {
            console.log(`CarouselScroll - centerize: nSlides changed to ${nSlides}, set activeIndex from ${activeIndex} to ${centerOffset}`);
            setCenterIndex(centerOffset);
            setActiveIndex(centerOffset);
        }
    }, [nSlides]);

    const getValidateIndex = useCallback((index: number) => {
        if (nSlides > 0) {
            if (index < 0) index = looping ? nSlides + index % nSlides : 0;
            if (index > nSlides - 1) index = looping ? index % nSlides : nSlides - 1;
        }
        return index;
    }, [looping, nSlides]);

    const gotoSlide = useCallback((index: number) => {
        if (autoPlay)
            setAutoPlay?.(false);
        index = getValidateIndex(index);
        setActiveIndex(index);
    }, [autoPlay, getValidateIndex, setActiveIndex]);

    const gotoPreviousSlide = useCallback(() => {
        if (autoPlay)
            setAutoPlay?.(false);
        setActiveIndex(previousActiveIndex => {
            return getValidateIndex(previousActiveIndex - 1);
        });
    }, [looping, nSlides, setActiveIndex]);

    const gotoNextSlide = useCallback(() => {
        if (autoPlay)
            setAutoPlay?.(false);
        setActiveIndex(previousActiveIndex => {
            return getValidateIndex(previousActiveIndex + 1);
        });
    }, [looping, nSlides, setActiveIndex]);

    const onSlideClick = useCallback((index: number) => {
        console.log(`CarouselProvider: onSlideClick called with index=${index}`);
        if (autoPlay)
            setAutoPlay?.(false);
        // gotoSlide(index);
    }, [
        autoPlay
        // , gotoSlide
    ]);

    useEffect(() => {
        if (!autoPlay || !autoPlayInterval) return;

        const interval = setInterval(() => {
            setActiveIndex(previousActiveIndex => {
                return getValidateIndex(previousActiveIndex + 1);
            });
        }, autoPlayInterval);
        return () => clearInterval(interval);
    }, [autoPlay, autoPlayInterval, gotoNextSlide]);


    // const carouselProviderSetActiveIndex = useMemo(() => {
    //     return (index: number) => {
    //         console.log(`CarouselProvider: setActiveIndex called with index=${index}`);
    //         if (nSlides > 0) {
    //             if (index < 0) index = looping ? nSlides + index % nSlides : 0;
    //             if (index > nSlides - 1) index = looping ? index % nSlides : nSlides - 1;
    //         }
    //         console.log(`CarouselProvider: setting activeIndex to ${index}`);
    //         setActiveIndex(index);
    //     };
    // }, [nSlides, looping]);

    const carouselProviderSetNSlides = useMemo(() => {
        return (n: number) => {
            // LogVerbose(`CarouselProvider: setNSlides called with n=${n}`);
            setNSlides(n);
        };
    }, []);

    const carouselProviderSetAutoPlay = useMemo(() => {
        return (value: boolean) => {
            // LogVerbose(`CarouselProvider: setAutoPlay called with value=${value}`);
            setAutoPlay(value);
        };
    }, []);


    LogVerbose(`Rendering CarouselProvider: nSlides=${nSlides}, activeIndex=${activeIndex}, centerIndex=${centerIndex}, looping=${looping}, autoPlayOnStart=${autoPlayOnStart}`);
    return (
        <carouselContext.Provider value={{
            nSlides,
            centerIndex,
            refSlideIndex,
            setNSlides: carouselProviderSetNSlides,
            name,
            looping,
            activeIndex,
            // setActiveIndex: carouselProviderSetActiveIndex,
            gotoSlide,
            gotoPreviousSlide,
            gotoNextSlide,
            onSlideClick,
            autoPlay,
            setAutoPlay: carouselProviderSetAutoPlay,
            autoPlayInterval
        }} >
            <div className={`mymh-carousel-container ${extraClass || ''}`} id={name}>
                {children}
            </div>
        </carouselContext.Provider>
    );
};

